// Phase 6E: rental rate / minimum-term formatting helpers.

export function formatMoney(v) {
    if (v == null || v === "") return "—";
    const n = Number(v);
    if (Number.isNaN(n)) return "—";
    return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

/** Compact one-liner for chips: "$5,000/mo · 3 mo min" or "$200/day". */
export function formatRateChip(rental) {
    if (!rental) return "";
    const period = rental.billing_period || (rental.monthly_rate && !rental.daily_rate ? "monthly" : "daily");
    let rate = "";
    if (period === "monthly" && rental.monthly_rate != null) {
        rate = `${shortMoney(rental.monthly_rate)}/mo`;
    } else if (rental.daily_rate != null) {
        rate = `${shortMoney(rental.daily_rate)}/day`;
    } else if (rental.monthly_rate != null) {
        rate = `${shortMoney(rental.monthly_rate)}/mo`;
    }
    if (rental.minimum_term_months) {
        rate = rate ? `${rate} · ${rental.minimum_term_months} mo min` : `${rental.minimum_term_months} mo min`;
    }
    return rate;
}

function shortMoney(v) {
    if (v == null) return "—";
    const n = Number(v);
    if (Number.isNaN(n)) return "—";
    if (n >= 1000 && Number.isInteger(n)) return `$${(n / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })}k`;
    return `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

/** Best-effort start_date + N months → ISO date string (YYYY-MM-DD), or "". */
export function addMonthsIso(startIso, months) {
    if (!startIso || !months) return "";
    try {
        const d = new Date(`${String(startIso).slice(0, 10)}T00:00:00`);
        const day = d.getDate();
        const m = d.getMonth() + Number(months);
        const y = d.getFullYear() + Math.floor(m / 12);
        const newMonth = ((m % 12) + 12) % 12;
        const newDate = new Date(y, newMonth, 1);
        const lastDay = new Date(y, newMonth + 1, 0).getDate();
        newDate.setDate(Math.min(day, lastDay));
        return newDate.toISOString().slice(0, 10);
    } catch {
        return "";
    }
}

/** Multi-line preview shown under the rental form (e.g. "$5,000.00 / month · 3-month minimum · earliest end date 2026-07-01"). */
export function buildRatePreview({ daily_rate, monthly_rate, minimum_term_months, billing_period, start_date }) {
    const period = billing_period || (monthly_rate != null && daily_rate == null ? "monthly" : (daily_rate != null ? "daily" : null));
    const parts = [];
    if (period === "monthly" && monthly_rate != null) {
        parts.push(`${formatMoney(monthly_rate)} / month`);
    } else if (period === "daily" && daily_rate != null) {
        parts.push(`${formatMoney(daily_rate)} / day`);
    } else if (monthly_rate != null) {
        parts.push(`${formatMoney(monthly_rate)} / month`);
    } else if (daily_rate != null) {
        parts.push(`${formatMoney(daily_rate)} / day`);
    }
    if (minimum_term_months) {
        parts.push(`${minimum_term_months}-month minimum`);
        const earliest = addMonthsIso(start_date, minimum_term_months);
        if (earliest) parts.push(`earliest end date ${earliest}`);
    }
    return parts.join(" · ");
}
